export default {
  getActiveQuestionIndex: state => {
    return state.activeQuestionIndex
  },
  isActiveQuestionIndex: state => index => {
    return state.activeQuestionIndex === index
  }
}
